<script setup>
import { ref } from 'vue';
import MapPointAutocenterCard from '@/components/cards/MapPointAutocenterCard.vue';
import MapPointCard from '@/components/cards/MapPointCard.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '@/assets/styles/swiper-custom.scss';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: () => '',
  },
  service: {
    type: String,
    default: () => '',
  },
  isServiceActive: {
    type: Boolean,
    default: () => false,
  },
});

const isLocked = ref(true);
const onSwiper = (swiper) => {
  isLocked.value = swiper.isLocked;
};

const onLockToggle = (swiper) => {
  isLocked.value = swiper.isLocked;
};
</script>
<template>
  <div class="points__slider">
    <Swiper
      :slides-per-view="'auto'"
      :space-between="16"
      :modules="[Navigation, Pagination]"
      :navigation="{
        prevEl: '.points__slider-navigation-prev',
        nextEl: '.points__slider-navigation-next',
      }"
      :pagination="{
        el: '.points__slider-pagination',
      }"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
      @swiper="onSwiper"
      @lock="onLockToggle"
      @unlock="onLockToggle"
    >
      <SwiperSlide v-for="(item, index) in data" :key="index">
        <MapPointAutocenterCard
          v-if="type === 'autocenter_list' || type === 'autocenter_list_car'"
          :salon="item"
          :service="item?.service"
          :type="'autocenter'"
          :name="item?.name"
          :marker="item?.marker"
          :brands-text="$t('networkMap.brands')"
          :choose-autocenter-text="$t('networkMap.choose_autocenter')"
          :leave-request-text="$t('networkMap.leave_request')"
          :service-center-text="$t('networkMap.service_center')"
          :autocenter-text="$t('networkMap.autocenter')"
          :is-service-active="isServiceActive"
        />
        <MapPointCard
          v-else-if="
            type === 'autoservice_list' || type === 'autoservice_list_one'
          "
          :id="item?.id"
          :type="'autocenter'"
          :name="item?.name"
          :marker="item?.marker"
          :address="item?.address"
          :phone="item?.phone"
          :time="item?.time"
          :services="item?.services"
          :link="item?.link"
          :services-text="$t('networkMap.services')"
          :choose-autocenter-text="$t('networkMap.choose_autocenter')"
          :leave-request-text="$t('networkMap.leave_request')"
        />
        <MapPointCard
          v-else-if="type === 'autocenter_list_buses'"
          :id="item?.id"
          :type="'autocenter'"
          :name="item?.name"
          :marker="item?.marker"
          :address="item?.address"
          :phone="item?.phone"
          :time="item?.time"
          :link="item?.link"
          :choose-autocenter-text="$t('networkMap.choose_autocenter')"
          :leave-request-text="$t('networkMap.leave_request')"
        />
        <MapPointCard
          v-else-if="type === 'service'"
          :id="item?.id"
          :type="type"
          :name="item?.name"
          :marker="item?.marker"
          :address="item?.address"
          :phone="item?.phone"
          :time="item?.time"
          :link="item?.link"
          :leave-request-text="$t('networkMap.leave_request')"
          :service="service"
        />
        <MapPointCard
          v-else-if="type === 'horeca_list'"
          :type="type"
          :name="item?.name"
          :marker="item?.marker"
          :address="item?.address"
          :phone="item?.phone"
          :time="item?.time"
          :email="item?.email"
          :button="item?.button"
          :socials="item?.socials"
        />
        <MapPointCard
          v-else
          :id="item?.id"
          :type="type"
          :name="item?.name"
          :marker="item?.marker"
          :address="item?.address"
          :phone="item?.phone"
          :time="item?.time"
          :brands="item?.brands"
          :link="item?.link"
          :fuel="item?.fuel"
          :services="item?.services"
          :fuel-text="$t('networkMap.fuel')"
          :services-text="$t('networkMap.available_services')"
        />
      </SwiperSlide>
    </Swiper>
    <div
      v-show="!isLocked"
      class="swiper-pagination swiper-pagination--onblack points__slider-pagination"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
    ></div>
    <div
      v-show="!isLocked"
      class="swiper-navigation points__slider-navigation"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
    >
      <Button
        type="button"
        rounded
        variant="outlined"
        class="points__slider-navigation-prev button-prev js-button-points-prev"
      >
        <CIcon
          class="button-prev__icon"
          name="direction-black"
          width="16"
          height="16"
        />
      </Button>
      <Button
        type="button"
        rounded
        variant="outlined"
        class="points__slider-navigation-next button-next js-button-points-next"
      >
        <CIcon
          class="button-next__icon"
          name="direction-black"
          width="16"
          height="16"
        />
      </Button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:math';
.points {
  &__slider {
    .swiper {
      height: 100%;
      overflow: visible;
      width: 100%;
    }
    .swiper-slide {
      align-self: stretch;
      height: auto;
      width: 312px;
      max-width: calc(100vw - 48px);
      @include media-breakpoint-up(sm) {
        max-width: unset;
        width: 348px;
      }
      @include media-breakpoint-up(md) {
        width: 384px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(width, 384);
      }
    }
    &-navigation {
      padding-top: 24px;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(padding-top, 24);
      }
    }
  }
}
</style>
